export const putShareIS = {
	putShare: null,

	loading: false,
	error: null,
	errorShow: false,
};
